import React from 'react';
import { List } from 'antd';

const TotalList = ({ totalHT, totalRemise, totalTVA, totalTTC }) => {
  return (
    <List
      size="small"
      bordered
      dataSource={[
        { label: 'Total HT:', value: totalHT },
        { label: 'Total Remise:', value: totalRemise },
        { label: 'Total TVA:', value: totalTVA },
        { label: 'Total TTC:', value: totalTTC },
      ]}
      renderItem={item => (
        <List.Item style={{ display: 'flex', justifyContent: 'space-between' }}>
          <strong>{item.label}</strong>
          <strong style={{ color: 'green' }}>{item.value}</strong>
        </List.Item>
      )}
    />
  );
};

export default TotalList;
